module.exports = __webpack_public_path__ + "static/media/HeaderLogos.b03d5bf3.svg";